export default function BoyntonBeachStickyNav() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const links = [
    { label: "Areas We Serve", id: "service-area" },
    { label: "Services", id: "services" },
    { label: "Travel Timing", id: "travel-timing" },
    { label: "Destinations", id: "destinations" },
    { label: "Reviews", id: "reviews" },
    { label: "How It Works", id: "how-it-works" },
    { label: "FAQ", id: "faq" },
    { label: "Resources", id: "local-resources" },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-1 overflow-x-auto no-scrollbar py-3">
          {links.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="flex-shrink-0 text-xs font-medium text-[#1A365D] hover:text-[#F6C344] hover:bg-[#F7F8FA] px-3 py-2 rounded-md transition-all whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="flex-shrink-0 ml-auto text-xs font-bold text-[#1A365D] bg-[#F6C344] hover:bg-[#e5b430] px-4 py-2 rounded-md transition-all whitespace-nowrap"
          >
            Get Started
          </a>
        </div>
      </div>
    </nav>
  );
}